@if (isButtonView) {
	<div
		class="checkBoxButtonContainer capability{{ trainingRoom?.roomCapabilities }}"
		[class.disabled]="disabled"
		matTooltip="{{ T.SHARED_TRAINING_ROOM_BUTTON_OFFLINE | translate }}"
		[matTooltipDisabled]="!disabled"
		[class.allowSelectionWhenOccupied]="allowSelectionWhenOccupied"
		[ngClass]="buttonState"
		[class.fullWidth]="fullWidth"
		role="button"
	>
		<button
			[disabled]="!trainingRoom"
			[class.draggable]="draggable"
			mat-flat-button
			color="accent"
			[ngClass]="[buttonState]"
			[class.checked]="isChecked"
			(click)="checkButton()"
			[matTooltipClass]="buttonState === 'occupied' ? 'warn' : 'accent'"
			[matTooltip]="occupiedByName"
		>
			<div class="iconWrapper">
				<sim-animated-material-icon
					[trigger]="isChecked"
					[biggerFAIcon]="true"
					[startIcon]="getStartIcon()"
					[endIcon]="{
						fontSet: 'fad',
						fontIcon: 'fa-check',
						themeColor: 'accent',
					}"
				/>
			</div>
			<span class="btnTextWrapper">{{ trainingRoom?.name || (T.GLOBAL_TXT_LOADING_WITH_DOTS | translate) }}</span>
			@if (trainingRoom?.type !== TrainingRoomType.NonSimulation) {
				<button
					class="showMoreInfoMenueBtn"
					matTooltip="{{ T.SHARED_TRAINING_ROOM_BUTTON_SHOW_ROOM_INFO | translate }}"
					matTooltipClass="accent"
					[attr.tpye]="TrainingRoomType[trainingRoom?.type]"
					[disabled]="disabled"
					appStopPropagation
					mat-icon-button
					[matMenuTriggerFor]="menu"
				>
					<mat-icon fontSet="far" fontIcon="fa-ellipsis-v" inline />
				</button>
			}
			<mat-menu #menu="matMenu">
				<button mat-menu-item class="menueButtonWithFAIcon" (click)="openShowRoomDetailDialog()">
					<mat-icon fontSet="fad" fontIcon="fa-external-link" inline />
					<span>{{ T.SHARED_TRAINING_ROOM_BUTTON_SHOW_ROOM_DETAIL | translate }}</span>
				</button>
			</mat-menu>
		</button>
	</div>
}

@if (!isButtonView) {
	<div
		class="checkBoxCardContainer capability{{ trainingRoom?.roomCapabilities }}"
		[class.disabled]="disabled"
		[class.allowSelectionWhenOccupied]="allowSelectionWhenOccupied"
		matTooltip="{{ T.SHARED_TRAINING_ROOM_BUTTON_OFFLINE | translate }}"
		[matTooltipDisabled]="!disabled"
		[attr.title]="trainingRoom?.occupiedTrainingRoom?.occupiedByName"
		[ngClass]="buttonState"
	>
		<mat-card
			style="width: 100%; position: relative"
			role="button"
			mat-ripple
			[matRippleDisabled]="disabled"
			(click)="checkButton()"
			[class.draggable]="draggable"
			[ngClass]="[buttonState]"
			[matTooltipDisabled]="buttonState === 'normal' || buttonState === 'unavailable'"
			[matTooltipClass]="buttonState === 'occupied' ? 'warn' : 'accent'"
			[matTooltip]="occupiedByName"
			[class.checked]="isChecked"
		>
			@if (enableShowRoom && Utils.roomHasAnyNonEmptyLayout(trainingRoom)) {
				<button
					mat-mini-fab
					class="showRoomInDetailBtn small"
					[disabled]="disabled"
					[matTooltipPosition]="buttonState === 'occupied' || buttonState === 'debriefing' ? 'right' : 'below'"
					matTooltip="{{ T.SHARED_TRAINING_ROOM_BUTTON_SHOW_ROOM_INFO | translate }}"
					matTooltipClass="accent"
					appStopPropagation
					(click)="openShowRoomDetailDialog()"
					[attr.aria-label]="T.SHARED_TRAINING_ROOM_BUTTON_SHOW_ROOM_INFO | translate"
				>
					<mat-icon fontSet="fad" fontIcon="fa-external-link" inline />
				</button>
			}
			@if (trainingRoom?.type === TrainingRoomType.Physical || trainingRoom?.type === TrainingRoomType.NonSimulation) {
				<div class="trainingRoomGroupName">
					<span class="mat-small">{{
						trainingRoomGroup
							? trainingRoomGroup?.name
							: (trainingRoom?.trainingRoomGroupId | getTrainingRoomGroupById | async)?.name
					}}</span>
				</div>
			}
			<div class="row containingRoomRow">
				<div class="buttonWrapperCol">
					<div class="iconWrapperForRoomCard" [class.checked]="isChecked" [ngClass]="[buttonState]">
						<ng-container>
							<sim-animated-material-icon
								[trigger]="isChecked"
								[biggerFAIcon]="true"
								[startIcon]="getStartIcon()"
								[endIcon]="{
									fontSet: 'fad',
									fontIcon: 'fa-check',
									themeColor: 'white',
								}"
							/>
						</ng-container>
					</div>
				</div>
				<div class="roomInfoCol">
					<div class="trainingRoomCapabilites">
						<span class="mat-small">{{ trainingRoom?.roomCapabilities | getRoomCapabilityString }}</span>
					</div>
					<div class="trainingRoomName showDotsOnOverflow2">
						{{ trainingRoom?.name }}
					</div>
					<div class="statusIconForRoom">
						@switch (buttonState) {
							@case ("unavailable") {
								<i class="fad fa-wifi-slash"></i>
							}
							@case ("debriefing") {
								<i class="fad fa-signal-stream"></i>
							}
							@case ("occupied") {
								<i class="fad fa-digging"></i>
							}
							@case ("normal") {
								<i class="fad fa-check-double"></i>
							}
						}
					</div>
				</div>
			</div>
		</mat-card>
	</div>
}
